import { z } from 'zod';

export const configurationDAPISchema = z.array(
  z.object({
    name: z.string(),
  }),
);

export const configurationDAPILicenseSchema = z.array(
  z.object({
    licenseUrl: z.string().url(),
    licenseContent: z.string(),
    name: z.string(),
    accepted: z.boolean(),
  }),
);

export const configurationDAPIStatusSchema = z.object({
  validConnection: z.boolean(),
});
